'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002416 from "./presto.-Presto$$anon$16.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00242 from "./presto.-Presto$$anon$2.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$1() {
  this.baG = null;
  this.bay = null;
  this.baz = false;
  this.baH = null;
  this.baI = false;
  this.baL = null;
  this.baE = null;
  this.baF = false;
  this.baA = null;
  this.baB = false;
  this.baC = null;
  this.baD = false;
  this.baJ = false;
  this.baK = false;
  this.baG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.baL = "SingleAppToken";
}
export { $c_Lpresto_Presto$$anon$1 as $c_Lpresto_Presto$$anon$1 };
$p = $c_Lpresto_Presto$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$1;
/** @constructor */
function $h_Lpresto_Presto$$anon$1() {
}
export { $h_Lpresto_Presto$$anon$1 as $h_Lpresto_Presto$$anon$1 };
$h_Lpresto_Presto$$anon$1.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.baG;
});
$p.L = (function() {
  if ((!this.baz)) {
    this.bay = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.baz = true;
  }
  return this.bay;
});
$p.O = (function() {
  if ((!this.baI)) {
    this.baH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.baI = true;
  }
  return this.baH;
});
$p.E = (function() {
  return this.baL;
});
$p.t = (function() {
  if ((!this.baF)) {
    this.baE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.baF = true;
  }
  return this.baE;
});
$p.M = (function() {
  if ((!this.baB)) {
    this.baA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gv(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gv())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dPresto$0024$0024anon$00242.$c_Lpresto_Presto$$anon$2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.baB = true;
  }
  return this.baA;
});
$p.Q = (function() {
  if ((!this.baD)) {
    this.baC = new $j_presto$002e$002dPresto$0024$0024anon$002416.$c_Lpresto_Presto$$anon$16();
    this.baD = true;
  }
  return this.baC;
});
$p.w = (function() {
  if ((!this.baK)) {
    this.baJ = false;
    this.baK = true;
  }
  return this.baJ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee99) => ((p) => \u03b4scrutinee99.adb(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_Presto$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$1, "presto.Presto$$anon$1", ({
  N4: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$1 as $d_Lpresto_Presto$$anon$1 };
//# sourceMappingURL=presto.-Presto$$anon$1.js.map
